import { UserCore } from "@typings/userCore"

export async function getUserCore(authToken: string): Promise<UserCore> {
  const response = await fetch(`${import.meta.env.VITE_CORE_API_URL}/users`, {
    headers: { Authorization: `Bearer ${authToken}` },
  })

  if (!response.status) throw new Error(response.statusText)

  const { data } = await response.json()

  return data
}
